import { Button } from '@cian/ui-kit';
import { IconFilePrint16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ModalPrintContainer } from './ModalPrintContainer';
import { trackPrintConfirm } from './tracking';
import { closeModal, finishPrint, openModal, startPrint } from '../../../actions/print';
import { selectIsModalOpen, selectIsPrinting, selectOptions } from '../../../selectors/print';
import { selectSelectedProducts } from '../../../selectors/selected';
import { trackPrintAllClick } from '../../TopBar';

export function PrintContainer() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(selectIsModalOpen);
  const isPrinting = useSelector(selectIsPrinting);
  const options = useSelector(selectOptions);
  const selectedProducts = useSelector(selectSelectedProducts);

  const printStartedRef = React.useRef(false);

  const handlePrintClick = () => {
    trackPrintAllClick();
    dispatch(openModal());
  };

  const handleConfirmPrint = () => {
    trackPrintConfirm(selectedProducts, options);
    dispatch(startPrint());
    dispatch(closeModal());
  };

  // Вызываем диалог только после того, как React добавил печатную разметку и закрыл модалку.
  React.useEffect(() => {
    if (!isPrinting) {
      printStartedRef.current = false;
      return;
    }

    if (isModalOpen || printStartedRef.current) {
      return;
    }

    printStartedRef.current = true;

    try {
      window.print();
    } finally {
      dispatch(finishPrint());
    }
  }, [dispatch, isModalOpen, isPrinting]);

  return (
    <>
      {isModalOpen && <ModalPrintContainer onConfirm={handleConfirmPrint} />}
      <Button
        beforeIcon={<IconFilePrint16 color="icon-main-default" />}
        size="XS"
        theme="fill_white_primary"
        onClick={handlePrintClick}
      >
        Печатать
      </Button>
    </>
  );
}
